module.exports = __webpack_public_path__ + "images/b0c985a760971616f576e5dfb693099a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/tour_berlin/dan.jpg
// module id = 157
// module chunks = 24